import '../css/app.css';

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

// Import Medium Zoom Library
// https://github.com/francoischalifour/medium-zoom
import mediumZoom from 'medium-zoom';
mediumZoom('.zoom', {
    margin: 24,
    background: '#1B2022',
    scrollOffset: 0,
});

// Animate On Scroll Options
// https://github.com/michalsnik/aos
import AOS from 'aos';
AOS.init({
    disable: 'phone',
    duration: 400,
    offset: -80,
    once: true,
});

// FSLightbox Pro Version
import './fslightbox';
// fsLightboxInstances['gallery'].props.showThumbsOnMount = true;
//
// require('fslightbox');

// Show made by Spaceray Creative banner.
if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    var n = [
        '\n %c Made with ♥ by Spaceray Creative %c %c %c https://www.spaceraycreative.com/ \n\n',
        'color: #a0d39d; background: #0b4061; padding:5px 0;',
        'background: #4c4c4d; padding:5px 0;',
        'background: #4c4c4d; padding:5px 0;',
        'color: #fff; background: #1c1c1c; padding:5px 0;',
    ];
    window.console.log.apply(console, n);
} else
    window.console && window.console.log('Made with love ♥ by Spaceray Creative - https://www.spaceraycreative.com/');

